// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-appearance-view .AppearanceItem {
  margin: 20px 0;
  display: block;
  padding: 0 4% 10px 7%;
  text-decoration: none !important;
}
.fi-appearance-view .AppearanceHeader {
  padding: 10px 0 10px 10px;
  border-bottom: 1px solid var(--fi-color-light-gray);
  margin-bottom: 20px;
}
.fi-appearance-view .AppearanceContent {
  display: flex;
  padding-left: 10px;
}
.fi-appearance-view .AppearanceIcon {
  min-width: 160px;
  margin-left: 0;
  margin-right: 70px;
}
.fi-appearance-view .AppearanceIcon .WidgetAdministratePreview {
  width: 160px;
  height: 160px;
  background-size: cover;
  background-repeat: no-repeat;
  border: 1px solid var(--fi-border-color-light);
  border-radius: 5px;
}
.fi-appearance-view .AppearanceFlex {
  width: 100%;
  max-width: 800px;
}
.fi-appearance-view .AppearanceFlex div {
  display: flex;
  margin: auto;
}
.fi-appearance-view .AppearanceFlex div span:first-child {
  color: var(--fi-color-light);
  margin-right: 10px;
}
.fi-appearance-view .AppearanceFlex div .Ccm-Label {
  max-width: 140px;
}
.fi-appearance-view .AppearanceSidebarPreviewContent {
  padding: 10px;
}
.fi-appearance-view .widgetCcmIcon {
  position: relative;
}
.fi-appearance-view .widgetCcmIcon .BrandedBackgroundColorLowOpacity {
  content: "";
  position: absolute;
  width: 38px;
  height: 46px;
  margin: 34px 0 0 89px;
  top: 0;
}
.fi-appearance-view .AppearanceAuthPreview {
  width: 160px;
  height: 160px;
  position: relative;
  overflow: hidden;
}
.fi-appearance-view .AppearanceAuthPreview:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.fi-appearance-view .AppearanceAuthPreview fi-authenticate-login {
  display: block;
  transform: scale(0.3);
  margin: -230px;
}
.fi-appearance-view .AppearanceAuthPreview .Ccm-LoginContainer {
  display: block !important;
}
.fi-appearance-view .AppearanceAuthPreviewBackground {
  position: absolute;
  background: var(--fi-branded-image-landscape) center center no-repeat;
  background-size: cover;
  width: 500px;
  height: 300px;
  left: calc(50% - 250px);
  top: 0;
}`, "",{"version":3,"sources":["webpack://./Source/app/appearance/appearance-view.component.scss"],"names":[],"mappings":"AACI;EACI,cAAA;EACA,cAAA;EACA,qBAAA;EACA,gCAAA;AAAR;AAGI;EACI,yBAAA;EACA,mDAAA;EACA,mBAAA;AADR;AAII;EACI,aAAA;EACA,kBAAA;AAFR;AAKI;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;AAHR;AAKQ;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,8CAAA;EACA,kBAAA;AAHZ;AAOI;EACI,WAAA;EACA,gBAAA;AALR;AAOQ;EACI,aAAA;EACA,YAAA;AALZ;AAOY;EACI,4BAAA;EACA,kBAAA;AALhB;AAQY;EACI,gBAAA;AANhB;AAWI;EACI,aAAA;AATR;AAYI;EACI,kBAAA;AAVR;AAYQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,MAAA;AAVZ;AAcI;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAZR;AAeQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AAbZ;AAgBQ;EACI,cAAA;EACA,qBAAA;EACA,cAAA;AAdZ;AAiBQ;EACI,yBAAA;AAfZ;AAmBI;EACI,kBAAA;EACA,qEAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,MAAA;AAjBR","sourcesContent":[".fi-appearance-view {\r\n    .AppearanceItem {\r\n        margin: 20px 0;\r\n        display: block;\r\n        padding: 0 4% 10px 7%;\r\n        text-decoration: none !important;\r\n    }\r\n\r\n    .AppearanceHeader {\r\n        padding: 10px 0 10px 10px;\r\n        border-bottom: 1px solid var(--fi-color-light-gray);\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .AppearanceContent {\r\n        display: flex;\r\n        padding-left: 10px;\r\n    }\r\n\r\n    .AppearanceIcon {\r\n        min-width: 160px;\r\n        margin-left: 0;\r\n        margin-right: 70px;\r\n\r\n        .WidgetAdministratePreview {\r\n            width: 160px;\r\n            height: 160px;\r\n            background-size: cover;\r\n            background-repeat: no-repeat;\r\n            border: 1px solid var(--fi-border-color-light);\r\n            border-radius: 5px;\r\n        }\r\n    }\r\n\r\n    .AppearanceFlex {\r\n        width: 100%;\r\n        max-width: 800px;\r\n\r\n        div {\r\n            display: flex;\r\n            margin: auto;\r\n\r\n            span:first-child {\r\n                color: var(--fi-color-light);\r\n                margin-right: 10px;\r\n            }\r\n\r\n            .Ccm-Label {\r\n                max-width: 140px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .AppearanceSidebarPreviewContent {\r\n        padding: 10px;\r\n    }\r\n\r\n    .widgetCcmIcon {\r\n        position: relative;\r\n\r\n        .BrandedBackgroundColorLowOpacity {\r\n            content: '';\r\n            position: absolute;\r\n            width: 38px;\r\n            height: 46px;\r\n            margin: 34px 0 0 89px;\r\n            top: 0;\r\n        }\r\n    }\r\n\r\n    .AppearanceAuthPreview {\r\n        width: 160px;\r\n        height: 160px;\r\n        position: relative;\r\n        overflow: hidden;\r\n\r\n        // overlay to disable user interactions\r\n        &:after {\r\n            content: '';\r\n            display: block;\r\n            position: absolute;\r\n            top: 0;\r\n            right: 0;\r\n            bottom: 0;\r\n            left: 0;\r\n        }\r\n\r\n        fi-authenticate-login {\r\n            display: block;\r\n            transform: scale(0.3);\r\n            margin: -230px;\r\n        }\r\n\r\n        .Ccm-LoginContainer {\r\n            display: block !important;\r\n        }\r\n    }\r\n\r\n    .AppearanceAuthPreviewBackground {\r\n        position: absolute;\r\n        background: var(--fi-branded-image-landscape) center center no-repeat;\r\n        background-size: cover;\r\n        width: 500px;\r\n        height: 300px;\r\n        left: calc(50% - 250px);\r\n        top: 0;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
